import type { ReactNode } from "react";

import { Accordion, HTML, Skeleton, Typography } from "@aviary";

import * as styles from "./GenericCollapsible.styles";

interface Props {
  header: string;
  loading?: boolean;
  children: ReactNode;
  isDefaultExpanded?: boolean;
}

const GenericCollapsible = ({ header, loading, children, isDefaultExpanded = false }: Props) => {
  const renderHeader = () => (
    <Typography type="h4" isMarginless>
      {header}
    </Typography>
  );
  const renderLoadingState = () => (
    <Skeleton type="typography" typographySize="body" isFullWidth margin="bottom" height={3} />
  );

  const renderAccordion = () => (
    <Accordion
      isContentMarginless
      coreTriggerContent={renderHeader()}
      isDefaultExpanded={isDefaultExpanded}
    >
      <HTML css={styles.content}>{children}</HTML>
    </Accordion>
  );

  return loading ? renderLoadingState() : renderAccordion();
};

export { GenericCollapsible };
